export default function existy(arg) {
   // eslint-disable-next-line
   return arg != null;
}
